import AnswerButtonGroup from "@/components/train/AnswerButtonGroup";
import DnaHelix from "@/components/subject/DNASequence/DnaHelix.vue";
export default {
  name: "DNASequenceRender",
  components: {
    AnswerButtonGroup,
    DnaHelix
  },
  props: {
    review: {
      type: Object,
      default: () => null
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    options() {
      return ['正确', '错误'];
    },
    words() {
      return {
        'true': '正确',
        'false': '错误'
      };
    }
  },
  methods: {
    onChoosed(list) {
      this.$emit('answer', list && list.length > 0 ? list[0] === '正确' : null);
    }
  }
};